<div class="flex">
  <ng-container #menuContainer />
</div>
